import { ApiClient } from "../api.client";
import {
  ApproveUserRequest,
  ApproveUserResponse,
  GetVettingUsersRequest,
  GetVettingUsersResponse,
  RejectUserRequest,
  RejectUserResponse,
  ReissuePaymentLinkRequest,
  ReissuePaymentLinkResponse,
} from "./types";

const VettingApi = {
  getVettingUsers(params?: GetVettingUsersRequest) {
    return ApiClient.get<GetVettingUsersResponse>("/admin/users/vetting", {
      params,
    });
  },
  rejectUser({ userId, ...body }: RejectUserRequest) {
    return ApiClient.post<
      Omit<RejectUserRequest, "userId">,
      RejectUserResponse
    >(`/admin/users/${userId}/reject`, body);
  },
  approveUser({ userId, ...body }: ApproveUserRequest) {
    return ApiClient.post<
      Omit<ApproveUserRequest, "userId">,
      ApproveUserResponse
    >(`/admin/users/${userId}/approve`, body);
  },
  reissuePaymentLink({ userId }: ReissuePaymentLinkRequest) {
    return ApiClient.post<void, ReissuePaymentLinkResponse>(
      `/admin/users/${userId}/reissue-payment-link`
    );
  },
};

export { VettingApi };
